export const THEME_CONFIG = {
  locale: 'ar',
  topNavColor: '#f7a354ff',
  headerNavColor: '',
  currentTheme: 'dark',
  direction: 'rtl',
  navCollapsed: false,
  parcelMode: false,
};
